import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SkillConstants } from '../../../../../skill/constants/skill-constants';
import { CourseCatalogueSearchResult } from '../../../../../course-catalogue/models/course-catalogue-search-result';
import { MenuItem, MessageService } from 'primeng/api';
import { Skill } from '../../../../../skill/models/skill';
import { LinkedTrainingItem } from '../../../../../skill/models/linked-item';
import { CourseCatalogueSearchComponent } from '../../../../../course-catalogue/course-catalogue-search/course-catalogue-search.component';
import { SkillService } from '../../../../../skill/services/skill.service';
import { SkillPersistenceService } from '../../../../../skill/services/skill-persistence.service';
import { EqmsScopeManagementService } from '../../../../../shared/services/eqms-scope-management.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-skill-course-details',
  templateUrl: './skill-course-details.component.html',
  styleUrls: ['./skill-course-details.component.scss']
})
export class SkillCourseDetailsComponent implements OnInit {
@Output() activateTabIndex = new EventEmitter<number>();
  feature:string = SkillConstants.Skill_Feature;
  panelListScreen : string = SkillConstants.SkillCourseDetails;
  courseCatalogueSearchResult: CourseCatalogueSearchResult[] = []
  isSkillSaveInProgress: boolean = false;
  errorMessages: string[] = [];  
  items: MenuItem[] = [];
  showAddButton : boolean = false;
  selectedCourses : CourseCatalogueSearchResult[] = [];
  showCheckBoxes : boolean = true;
  linkedItemDataToDisplay:any;
  @Input() selectedScope: any;
  @Input() skillCode !: string;
  listOfselectedCourses:string[]=[];
  linkedTrainingItem : any;
  skillDetails !: Skill;
  scope?:number;
  trainingItemsList : LinkedTrainingItem[]=[];
  skill !: Skill;
  trainingItemNumbers : string[] = [];
  isUpdate: boolean = false;
  addAndClose : boolean = false;
  errorCount : number = 0;
  eqmsScopes:number[] = []
  displayDataCollected : string[] = []
  trainingItemsDataToDisplay : any;

  @ViewChild(CourseCatalogueSearchComponent)
  private courseSearch!: CourseCatalogueSearchComponent;
  
    constructor(
      private messageService : MessageService,
      private skillService : SkillService,
      private eqmsScopeManagementService: EqmsScopeManagementService,
      private skillPersistenceService : SkillPersistenceService){
      this.items = [
      {
          label: 'Add',
          command: this.add
      }
    ]
  
    }
    ngOnInit() : void{
      this.skillPersistenceService.closeAndResetSkillSlider$.subscribe((isClose) => {
        if (isClose) { this.closeAndResetSkillSlider(); }
      })
      this.skillPersistenceService.resetSelectionAfterAdd$.subscribe((reset) => {
        if (reset) { this.clearSelections(); }
      })
    }
  
  
    onSelectionOrDeselection = (courses: CourseCatalogueSearchResult[]) => {

      let selectedCoursesList: string[] = [];
      courses.forEach(element => {
        selectedCoursesList.push(element.courseNumber);
      });
      this.displayDataCollected=[]
      this.displayDataCollected = selectedCoursesList;
      this.selectedCourses = [];
      this.selectedCourses = cloneDeep(courses);
    }
  
    addSkillAndClose(){
      this.addAndClose = true;
      this.getLinkedItems(this.addAndClose)
    }
  
    add = () => {
      this.addAndClose = false;
      this.getLinkedItems(this.addAndClose);
    };

    closeAndResetSkillSlider(){
      this.selectedCourses = [];
      this.displayDataCollected = [];
      this.courseCatalogueSearchResult = [];
      this.showAddButton = false;
    }
  
    clearSelections() {
      this.selectedCourses = [];
      this.displayDataCollected = [];
      if (this.courseSearch) {
        this.courseSearch.clearSelectionsAfterBulkOperation();
      }
    }
  
    showOrHideAddButton = (displayAddBtn: boolean) => {
      this.showAddButton = displayAddBtn;
    }
  
    getLinkedItems(addAndClose:boolean)
    {
      this.eqmsScopes=[]
      const courseData = Object.assign([], this.selectedCourses);
      this.selectedCourses = courseData.map((course:any) => ({
        number: course.courseNumber,
        title: course.name,
        ...course, 
      }));
      this.errorCount=0;
         this.skillService.getSkillByCode(this.skillCode).subscribe((skill)=>{
        this.skill = skill;
        this.skillPersistenceService.updateSkillDetails(skill);
        if(this.skill != null)
        {
          this.isUpdate = true;
        }
        this.validateAndCreateOrUpdateSkill(addAndClose);
      });
    }
  
    validateAndCreateOrUpdateSkill(addAndClose:boolean){
      if(this.selectedCourses.length<=0)
      {
        this.validateToSelectAtleastOneTrainingItem();
      }
      else{
          if(this.isUpdate){
            this.validateIfTrainingITemIsAlreadySaved(this.selectedCourses);
          }
          else{
            this.validateIfTrainingItemIsAlreadySelected(this.selectedCourses);
          }

           this.getParentScopesAndCompare(this.selectedCourses, this.isUpdate, addAndClose); 
        }
    }
  
    updateSkill(matchingCourses: any[],addAndClose : boolean){
        this.skillPersistenceService.prepareDataForCourseTrainingItem(matchingCourses,
          this.isUpdate, this.skill);
        if (this.skillPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.length > 0) {
          const trainingItemCode = this.skillPersistenceService.duplicateTrainingItemNumbersWithRemoveStatus.map((item) => `${item}`).join(',');
          const validationMessage = SkillConstants.Skill_Warning_TrainingItemMovedToActiveMessage.replace(
            'TrainingItems',
            `\n${trainingItemCode}`
          );
          this.messageService.add({
            severity: SkillConstants.Severity_Warning,
            summary: `${validationMessage}`,
            sticky: true
          });
        }
        this.skillPersistenceService.updateSkill(addAndClose);
    }
  
  
    validateToSelectAtleastOneTrainingItem(){
      this.errorCount = 0;
      this.messageService.add({
        severity: SkillConstants.Severity_Err,
        summary: `${SkillConstants.AtleastOneTrainingItem_ShouldBeSelected}`,
        life: 20000
      });
      this.errorCount++; 
    }
  
    validateIfTrainingItemIsAlreadySelected(matchingCourses : any[]){
      var courseNumbers : string[] = [];
      matchingCourses.find(element => {
        if(Object.values(this.listOfselectedCourses.indexOf(element.courseNumber)>=0))
        {
          courseNumbers.push(element.courseNumber);
        }
        else
        {
          this.trainingItemsDataToDisplay.push(element.courseNumber);
        }
        });
        this.displayDataCollected = courseNumbers.filter( x => !this.trainingItemNumbers.find(a=> a==x) );
        this.selectedCourses = this.selectedCourses.filter(x => this.displayDataCollected.find(a=> a == x.courseNumber));
        const sameElements = courseNumbers.filter( x => this.trainingItemNumbers.find(a=> a == x));
        if(sameElements.length > 0){
          this.validationMessageForTrainingItemAlreadyExisting(sameElements);
        }
    }
  
    validateIfTrainingITemIsAlreadySaved(matchingCourses : any[]){
      var courseNumbers : string[] = [];
      this.trainingItemNumbers = [];
      const activeTrainingItemIds: string[] = [];
      this.skill.linkedTrainingItems?.find(element=>{
        this.trainingItemNumbers.push(element.trainingItemId);
        if (element.status !== SkillConstants.Skill_StatusRemoved) {
          activeTrainingItemIds.push(element.trainingItemId);
        }
      })
      matchingCourses.find(element => {
        if(Object.values(activeTrainingItemIds.indexOf(element.courseNumber)>=0))
        {
          courseNumbers.push(element.courseNumber);
        }
        });
        this.displayDataCollected = courseNumbers.filter( x => !activeTrainingItemIds.find(a=> a==x) );
        this.selectedCourses = this.selectedCourses.filter(x => this.displayDataCollected.find(a=> a == x.courseNumber));
        const sameElements = courseNumbers.filter( x => activeTrainingItemIds.find(a=> a == x));
        if(sameElements.length > 0)
        {
          this.validationMessageForTrainingItemAlreadyExisting(sameElements);
        }
    }
  
  
      //since scopes are not matching, we are trying to get its parent scopes and compare with selected form scopes
      getParentScopesAndCompare(serviceData: any[], isUpdate: boolean, addAndClose: boolean) {
        const scopes: any[] = [];
        this.selectedScope.map((scope: any) => {
          scopes.push(scope);
        });
        const matchingCourses: any[] = [];
        const mismatchedCourses: any[] = [];
        
        serviceData.forEach((data) => {
          const { eqmsScopes } = data;    
          const hasMatch = eqmsScopes.some((scope: number) => scopes.includes(scope));    
          if (hasMatch) {
            matchingCourses.push(data);
          } else {
            mismatchedCourses.push(data);
          }
        });
        if (mismatchedCourses.length) {
          this.displayScopeValidationMessage(mismatchedCourses);
        }
        if (matchingCourses.length) {
          this.selectedItems(matchingCourses);
          this.updateSkill(matchingCourses,addAndClose);
        }
      }

      selectedItems(serviceData : any[]){
        if (!this.trainingItemsDataToDisplay || this.trainingItemsDataToDisplay.length === 0) {
          this.trainingItemsDataToDisplay = serviceData;
        } else {
          this.trainingItemsDataToDisplay.push(...serviceData);
        }
      }
  
      displayScopeValidationMessage(mismatchedCourses: any[]) {
        this.errorCount = 0;
        const courseNumbersString = mismatchedCourses.map((course) => `  ${course.courseNumber}`).join(', ');
        const validationMessage = SkillConstants.Selected_CourseScopes_Not_Matching_Error_Message.replace(
          'CourseNumbers',
          `\n${courseNumbersString}`
        );
        this.messageService.add({
          severity: SkillConstants.Severity_Err,
          summary: `${validationMessage}`,
          life: 20000
        });
        this.errorCount++; 
      }
  
      validationMessageForTrainingItemAlreadyExisting(mismatchedCourses : any[]){
        this.errorCount = 0;
        const courseNumbersString = mismatchedCourses.map((course) => `  ${course}`).join(', ');
          const validationMessage = SkillConstants.LinkedCourse_AlreadyExists_InSkill.replace(
            'CourseNumbers',
            `\n${courseNumbersString}`
          );
          this.messageService.add({
            severity: SkillConstants.Severity_Err,
            summary: `${validationMessage}`,
            life: 20000 
          });
          this.errorCount++;
        }
}
